export default {
  namespaced: true,
  state: {
    drawer: false,
    leftBuildingDrawer: false,
    rightBuildingDrawer: false,
    leftFacilityDrawer: false,
    rightFacilityDrawer: false,
    processDocuDrawer: false,
    rightProcessDrawer: false,
    rightOnboardingDrawer: false,
    theme: false,
    facilityInfoTabs: [],
  },
  mutations: {
    toggleLeftBuildingDrawer(state) {
      state.leftBuildingDrawer = !state.leftBuildingDrawer;
    },
    toggleRightBuildingDrawer(state) {
      state.rightBuildingDrawer = !state.rightBuildingDrawer;
    },
    toggleLeftFacilityDrawer(state) {
      state.leftFacilityDrawer = !state.leftFacilityDrawer;
    },
    toggleRightFacilityDrawer(state) {
      state.rightFacilityDrawer = !state.rightFacilityDrawer;
    },
    toggleProcessDocuDrawer(state) {
      state.processDocuDrawer = !state.processDocuDrawer;
    },    
    toggleRightProcessDrawer(state) {
      state.rightProcessDrawer = !state.rightProcessDrawer;
    },
    toggleRightOnboardingDrawer(state) {
      state.rightOnboardingDrawer = !state.rightOnboardingDrawer;
    },
    toggleDrawer(state) {
      state.drawer = !state.drawer;
    },
    toggleTheme(state) {
      state.theme = !state.theme;
    },
    setFacilityInfoTabs(state, value) {
      state.facilityInfoTabs = value;
    }
  },
  actions: {
    TOOGLE_LEFT_BUILDING_DRAWER_STATE({commit}) {
      commit('toggleLeftBuildingDrawer');
    },
    TOOGLE_RIGHT_BUILDING_DRAWER_STATE({commit}) {
      commit('toggleRightBuildingDrawer');
    },
    TOOGLE_LEFT_FACILITY_DRAWER_STATE({commit}) {
      commit('toggleLeftFacilityDrawer');
    },
    TOOGLE_RIGHT_FACILITY_DRAWER_STATE({commit}) {
      commit('toggleRightFacilityDrawer');
    },
    TOOGLE_PROCESS_DOCU_DRAWER_STATE({commit}) {
      commit('toggleProcessDocuDrawer');
    },
    TOOGLE_RIGHT_PROCESS_DRAWER_STATE({commit}) {
      commit('toggleRightProcessDrawer');
    },
    TOOGLE_RIGHT_ONBOARDING_DRAWER_STATE({commit}) {
      commit('toggleRightOnboardingDrawer');
    },
    TOGGLE_DRAWER({commit}) {
      commit('toggleDrawer');
    },
    TOGGLE_THEME({commit}) {
      commit('toggleTheme');
    },
  },
  getters: {
    LEFT_BUILDING_DRAWER_STATE(state) {
      return state.leftBuildingDrawer;
    },
    RIGHT_BUILDING_DRAWER_STATE(state) {
      return state.rightBuildingDrawer;
    },
    LEFT_FACILITY_DRAWER_STATE(state) {
      return state.leftFacilityDrawer;
    },
    RIGHT_FACILITY_DRAWER_STATE(state) {
      return state.rightFacilityDrawer;
    },
    PROCESS_DOCU_DRAWER_STATE(state) {
      return state.processDocuDrawer;
    },    
    RIGHT_PROCESS_DRAWER_STATE(state) {
      return state.rightProcessDrawer;
    },
    RIGHT_ONBOARDING_DRAWER_STATE(state) {
      return state.rightOnboardingDrawer;
    },
    DRAWER_STATE(state) {
      return state.drawer;
    },
    THEME_STATE(state) {
      return state.theme;
    },
    facilityInfoTabs(state) {
      return state.facilityInfoTabs
    }
  },
}
